import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton, scrollToCompra } from './Shared';
import { TrustPanel } from './TrustPanel';
export const Hero = () => {
  return <section className="relative pt-14 pb-10 md:pt-20 md:pb-16 px-4 overflow-hidden" data-id="element-53">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-grass-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-54" />

      <div className="max-w-3xl mx-auto relative z-10 text-center flex flex-col items-center gap-6 md:gap-8" data-id="element-55">
        <motion.h1 initial={{
        opacity: 0,
        y: -15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="font-anton text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-white uppercase tracking-wide" data-id="element-56">
          Convertite en el arquero que{' '}
          <span className="text-grass-400" data-id="element-57">salva al equipo</span> cuando más lo
          necesita
        </motion.h1>

        <div onClick={scrollToCompra} className="cursor-pointer w-full max-w-xl" data-id="element-58">
          <img src="https://cdn.magicpatterns.com/uploads/qHttqE6tY5gAoDMtKKdfjE/TRANSFORMA_TU_PRACTICA_ORTOPEDICA_AL_SIGUIENTE_NIVEL_(1).png" alt="Arquero PRO System - Producto completo" loading="eager" className="w-full h-auto object-contain drop-shadow-[0_15px_35px_rgba(130,194,72,0.2)]" data-id="element-59" />
        </div>

        <p className="text-base md:text-xl text-forest-200 font-medium max-w-2xl -mt-2" data-id="element-60">
          Para los arqueros que entrenan mucho, pero en los partidos siguen
          recibiendo goles fáciles de atajar.
        </p>

        <CTAButton data-id="element-61">Quiero mejorar mi nivel →</CTAButton>

        <TrustPanel data-id="element-62" />
      </div>
    </section>;
};